import { render, staticRenderFns } from "./BlockSplit.vue?vue&type=template&id=98a8bd16"
import script from "./BlockSplit.vue?vue&type=script&lang=js"
export * from "./BlockSplit.vue?vue&type=script&lang=js"
import style0 from "./BlockSplit.vue?vue&type=style&index=0&id=98a8bd16&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports